import BaseResource from './BaseResource'

export default class Conveyors extends BaseResource {
  static endpoint = '/api/v1/conveyors' // /edge
}
